import React, { Component, PropTypes } from 'react';
import MemberForm from 'components/membership/MemberForm';
import Spinner from 'components/shared/spinner';
import { getEmailList, createMember, subscribe, saveAuthData } from 'utils/MemberUtils';
import EmailPreferenceTypes from 'constants/EmailPreferenceTypes';
import MemberFormDefaultMessage from 'constants/MemberFormDefaultMessage';

class Register extends Component {
  static propTypes = {
    successMsg: PropTypes.string,
    mainErrorMsg: PropTypes.string
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    successMsg: MemberFormDefaultMessage.REGISTER_SUCCESS,
    mainErrorMsg: MemberFormDefaultMessage.REGISTER_FAIL
  }

  state = {
    emailList: [],
    submitted: false,
    errorMsgs: [],
    isLoading: false
  }

  componentDidMount() {
    getEmailList().then(data => {
      const {
        data: emailList = []
      } = data;
      this.setState({ emailList });
    }).catch(error => {
      const {
        data,
        status = 'Error',
        statusText = ''
      } = error;

      this.setState({
        errorMsgs: data || [ `${status} ${statusText}` ]
      });
    });
  }

  _onSubmit(memberData, preference) {
    const {
      flux,
      config: {
        affiliate: {
          expiredTime: { member: expire = 1800 } = {}
        }
      } = {}
    } = this.context;

    createMember(memberData).then(resp => {
      const { member, token } = resp;

      if (member) {
        saveAuthData({ member, token }, expire);
        flux.getActions('Member').login();

        const emailList = preference.map(item => {
          return {
            emaillist: { id: item },
            emaillisttypes: [EmailPreferenceTypes.HTML]
          };
        });

        subscribe({emailList, token}).then(() => {
          this.setState({
            submitted: true,
            isLoading: false
          });
        }).catch(error => {
          throw error;
        });
      }
    }).catch(error => {
      this.setState({
        errorMsgs: error.data || [],
        isLoading: false
      });
    });

    this.setState({
      isLoading: true
    });
  }

  _onRetryButtonClick() {
    this.setState({
      errorMsgs: []
    });
  }

  render() {
    const {
      successMsg,
      mainErrorMsg
    } = this.props;

    const {
      emailList,
      submitted,
      errorMsgs,
      isLoading
    } = this.state;

    if (isLoading) {
      return (
        <div className="FormLoading">
          <Spinner active />
        </div>
      );
    }

    if (submitted) {
      return (
        <div className="Notification Notification--success">
          <div className="Notification-message" dangerouslySetInnerHTML={{__html: successMsg}}></div>
        </div>
      );
    }

    if (errorMsgs.length) {
      return (
        <div className="Notification Notification--error">
          <div className="Notification-message" dangerouslySetInnerHTML={{__html: mainErrorMsg}}></div>
          {
            errorMsgs.map((msg, index) => <div key={index} className="Notification-message">{msg}</div>)
          }
          <div className="Notification-footer">
            <button className="Notification-btn" onClick={() => this._onRetryButtonClick()}>{MemberFormDefaultMessage.TRY_AGAIN}</button>
          </div>
        </div>
      );
    }

    return (
      <MemberForm
        emailList={emailList}
        btnText="register"
        onSubmit={(memberData, preference) => this._onSubmit(memberData, preference)} />
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./app/components/membership/Register.js